var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"ShopHome"}},[_c('router-view',{on:{"getFocus":_vm.showBottom}}),_vm._v(" "),_c('bottomNav',{directives:[{name:"show",rawName:"v-show",value:(_vm.flag),expression:"flag"}],attrs:{"tab":_vm.changeIndex,"viewName":'homepage'}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-188e9cc1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/shopping/homePage.vue
// module id = null
// module chunks = 